import React, {useCallback, useContext, useEffect, useMemo} from "react";
import {useRequest} from "../../../utils/hooks.jsx";
import {Spin} from "antd";
import {LoadingOutlined} from "@ant-design/icons";
import {SideBySideLayout} from "../../SideBySideLayout/index.js";
import "./jwt-login.css";
import {getSystemAuthPageByOrigin, redirectToMainView} from "../utils.jsx";
import {StyledButton} from "../../../components/index.jsx";
import {AppContext} from "../../../AppContext.jsx";

export const Test = () => {
    const [redirectResponse, isRedirectLoading, redirectResponseError] = useRequest(`/api/system/auth`, "POST", null);
    return (
        <div
            className="jwt-login-auth"
            style={{height: "100vh", display: "flex", justifyContent: "center", flexDirection: "column"}}>
            <StyledButton
                className="regular-login-button"
                onClick={() => {
                    window.location.replace(`/auth/jwt`);
                }}>
                מעבר למרקטפלייס רווחת העובדים של ישראל
            </StyledButton>
        </div>
    );
};

export const JWTLogin = ({location, history}) => {
    const {loginComplete: onSuccess} = useContext(AppContext);

    const [redirectResponse, isRedirectLoading, redirectResponseError] = useRequest(`/api/system/auth`, "GET");

    const onLoginSuccess = useCallback(async () => {
        await onSuccess();
        redirectToMainView(history, location);
    }, [onSuccess, history, location]);

    useEffect(() => {
        if (redirectResponse) {
            onLoginSuccess();
        }
    }, [onLoginSuccess, redirectResponse]);

    const loginPageImage = useMemo(() => getSystemAuthPageByOrigin(window.location.origin), []);

    return (
        <SideBySideLayout srcImage={loginPageImage}>
            <div className="jwt-login-auth">
                {redirectResponseError ? (
                    <>
                        <div className="loading-title">קרתה שגיאה</div>
                        <StyledButton className="regular-login-button" onClick={() => window.history.back()}>
                            חזור
                        </StyledButton>
                    </>
                ) : (
                    <>
                        <div className="loading-title">טוען מידע אנא המתן...</div>
                        <Spin indicator={<LoadingOutlined className="jwt-loading" />} size="large" />
                    </>
                )}
            </div>
        </SideBySideLayout>
    );
};
